import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UsersService } from "../services/users.service";

declare var g_Profile: any;

@Component({
    selector: 'app-system',
    templateUrl: './system.component.html',
    styleUrls: ['./system.component.css'],
    standalone: false
})

export class SystemComponent implements AfterViewInit, OnDestroy, OnInit {
    isProfileReady: boolean;
    profileCheckInterval: NodeJS.Timeout;
    constructor(private translate: TranslateService, private usersService: UsersService) {
        this.translate = translate;
    }


    ngOnInit(): void {
        this.startProfilePolling();
    }
    ngOnDestroy(): void {
        this.clearProfilePolling();
    }

    // Method to check if profile exists
    public checkProfileLoaded = (): boolean => {
        const profileExists = typeof g_Profile !== 'undefined' && g_Profile;
        return profileExists;
    };

    // Start checking for profile every 100ms
    private startProfilePolling(): void {
        // Initial check
        this.isProfileReady = this.checkProfileLoaded();

        if (!this.isProfileReady) {
            this.profileCheckInterval = setInterval(() => {
                this.isProfileReady = this.checkProfileLoaded();

                // If profile is loaded, clear the interval
                if (this.isProfileReady) {
                    this.clearProfilePolling();
                }
            }, 100); // Check every second (100ms)
        }
    }

    private clearProfilePolling(): void {
        if (this.profileCheckInterval) {
            clearInterval(this.profileCheckInterval);
            this.profileCheckInterval = null;
        }
    }

    

    ngAfterViewInit() {
        this.updateTitle();
        this.usersService.onInit.subscribe(() => { this.updateTitle(); });
        this.translate.onLangChange.subscribe(() => { this.updateTitle(); });
    }
    private updateTitle() {
        document.title = this.translate.instant(this.usersService.getTitle());
    }
}
